import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MenuItemPrice, MenuItemTopping, MenuItemToppingPrice} from 'brewbill-lib';

@Component({
    selector: 'bb-edit-menu-item-topping',
    templateUrl: './edit-menu-item-topping.component.html',
    styleUrls: ['./edit-menu-item-topping.component.scss'],
})
export class EditMenuItemToppingComponent implements OnInit, OnChanges {
    @Input() menuItemTopping: MenuItemTopping;
    @Input() menuItemPrices: MenuItemPrice[];
    innerPrices: MenuItemToppingPrice[];
    priceType = 'SINGLE';

    constructor() {
    }

    ngOnInit() {
        this.priceType = (!!this.menuItemTopping.prices && this.menuItemTopping.prices.some(p => !!p.menuItemPrice))
            ? 'BY_PRICE' : 'SINGLE';
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!!changes.menuItemPrices) {
            if (!!this.menuItemPrices
                && !!this.menuItemTopping.prices
                && !this.menuItemTopping.prices.some(p => !p.menuItemPrice)) {

                const temp = this.menuItemTopping.prices.filter(i => !!i.menuItemPrice
                    && this.menuItemPrices.some(p => p.key === i.menuItemPrice.key));

                temp.forEach(i => i.menuItemPrice = this.menuItemPrices.find(p => p.key === i.menuItemPrice.key));

                this.menuItemTopping.prices = temp;
            }
        }
    }

    preparePrices() {
        if (this.priceType === 'SINGLE') {
            if (!this.menuItemTopping.prices
                || this.menuItemTopping.prices.length !== 1
                || this.menuItemTopping.prices.some(p => !!p.menuItemPrice)) {
                this.innerPrices = [
                    new MenuItemToppingPrice({
                        price: null
                    })
                ];
            } else {
                this.innerPrices = [new MenuItemToppingPrice(this.menuItemTopping.prices[0])];
            }
        } else {
            const temp = [];
            if (!!this.menuItemTopping.prices) {
                this.menuItemPrices.forEach(menuItemPrice => {
                    const found = this.menuItemTopping.prices.find(p => !!p.menuItemPrice && p.menuItemPrice.key === menuItemPrice.key);
                    if (!!found) {
                        temp.push(new MenuItemToppingPrice(found));
                    } else {
                        temp.push(new MenuItemToppingPrice({
                            price: null,
                            menuItemPrice
                        }));
                    }
                });

            }
            this.innerPrices = temp;
        }
    }

    priceNone() {
        return !this.menuItemTopping.prices
            || this.menuItemTopping.prices.length === 0
            || !this.menuItemTopping.prices.some(p => p.price > 0);
    }

    setPrices() {
        this.menuItemTopping.prices = [...this.innerPrices];
        this.innerPrices = null;
    }
}
